import Vue from "vue";
import router from "./router";
import store from "./store";
import axios from "axios";

import App from "./App.vue";
import Base from "./layouts/Base.vue";
import Default from "./layouts/Default.vue";
import NoProgress from "./layouts/NoProgress.vue";
import { api } from "./store/http";

const token = localStorage.getItem("token");
console.log("token is", token);

Vue.prototype.$http = axios;
Vue.prototype.$api = api;

Vue.component("base-layout", Base);
Vue.component("default-layout", Default);
Vue.component("no-progress-layout", NoProgress);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
